//var $ = require("../lib/jquery-1.11.2.mod.js");
var Util = require("../lib/util.js");
var console = require("../lib/logger.js");
var FrameReadyEventBroker = require("./framereadyeventbroker.js");
var configModule = require("../define/config.js");
var SecureFrameProxy = require("../lib/secureframeproxy.js");

function Handshake () {

}

Handshake.util = {};

Handshake.util.getExtensionFrameIndex = function (extensionFrameWindow) {

    var extensionFrameIndex = -1;
    var frameCount = window.frames.length;

    // Strange behavior on Pintrest when using IE 11,
    // window.frames.length would be "undefined"
    if (frameCount == null) {

        frameCount = 100;
    }

    for (var index = 0; index < frameCount; index++) {

        if (Util.isSameWindow(window.frames[index], extensionFrameWindow) === true) {

            extensionFrameIndex = index;
            break;
        }
    }

    return extensionFrameIndex;
};

Handshake.frames = {};

Handshake.frames.topFrame = function (frameMessageBroker, frameProxyGroup, extensionFrameProxy) {

    var frameReadyEventBroker = new FrameReadyEventBroker();
    frameReadyEventBroker.setFrameMessageBroker(frameMessageBroker);

    var extensionFrameWindow = null;
    var extensionFrameIndex = -1;

    //prepare call back for FramerRady: add ready frame/topframe into group
    frameReadyEventBroker.onFrameReady(function (frameProxy) {
        console.log(__GLOBAL_LOG_PREFIX__, "TopFrame: Frame Ready");

        if (Util.isWindowAvailable(extensionFrameWindow) === true) {

            var currentIndex = Handshake.util.getExtensionFrameIndex(extensionFrameWindow);

            if (currentIndex > -1 &&
                currentIndex != extensionFrameIndex) {

                console.warn(__GLOBAL_LOG_PREFIX__, "Extension Frame index changed!!!");

                extensionFrameIndex = currentIndex;

                frameProxyGroup.updateMessage(
                    "ExtensionFrameReady",
                    {
                        extensionFrameIndex: extensionFrameIndex
                    }
                );
            }
        }

        var existedFrameProxy = frameProxyGroup.isAlreadyAdded(frameProxy);

        if (existedFrameProxy != null) {

            console.info(__GLOBAL_LOG_PREFIX__, "Frame already added!! Skip adding it to group");
            return;
        }

        frameProxyGroup.addMessageProxy(frameProxy);
    });

    //prepare call back for extFrameReady: broadcast extFrame info to group
    frameReadyEventBroker.onExtensionFrameReady(function (messageObj, frameProxy) {
        console.log(__GLOBAL_LOG_PREFIX__, "TopFrame: ExtensionFrame Ready");

        var targetInfo = frameProxy.getTargetInfo();

        extensionFrameWindow = targetInfo.window;

        extensionFrameIndex = Handshake.util.getExtensionFrameIndex(extensionFrameWindow);

        frameProxyGroup.broadcastMessage(
            "ExtensionFrameReady",
            {
                extensionFrameIndex: extensionFrameIndex
            },
            null,
            true
        );

        targetInfo.origin = configModule.EXTENSIONFRAME_BASEURL;

        extensionFrameProxy.setTargetInfo(targetInfo);

        var messageObjTmp = {
            targetId: messageObj.targetId,
            messageId: "ExtensionFrameProxyReady",
            message: null,
            senderId: messageObj.senderId
        };

        extensionFrameProxy.forwardMessage(messageObjTmp);
    });
};

Handshake.frames.frame = function (topFrameProxy, extensionFrameProxy, decKey) {

    //pepare callback when extensionFrame reported ready
    topFrameProxy.onMessage("ExtensionFrameReady", function(messageObj, messageProxy){
        console.log(__GLOBAL_LOG_PREFIX__, "Frame: ExtensionFrame Ready");

        var messageContent = messageObj.message;

        if (messageContent == null ||
            messageContent.extensionFrameIndex == null) {

            return;
        }

        var extensionFrameWindow = null;

        try {

            extensionFrameWindow = window.top.frames["extensionFrame"];

        } catch(e) {

            console.info(__GLOBAL_LOG_PREFIX__, "Cannot retrieve extensionFrame using name");
        }

        if (Util.isWindowAvailable(extensionFrameWindow) === false &&
            messageContent.extensionFrameIndex !== -1) {

            console.info(__GLOBAL_LOG_PREFIX__, "Retrieve extensionFrame using index");
            extensionFrameWindow = window.top.frames[messageContent.extensionFrameIndex];
        }

        if (Util.isWindowAvailable(extensionFrameWindow) === false) {

            console.error(__GLOBAL_LOG_PREFIX__, "Cannot retrieve extensionFrame!!");
            return;
        }
        
        var targetInfo = extensionFrameProxy.getTargetInfo();

        if (Util.isWindowAvailable(targetInfo.window) === true &&
            Util.isSameWindow(targetInfo.window, extensionFrameWindow) === true) {

            console.info(__GLOBAL_LOG_PREFIX__, "Same Extension Frame window");
            return;
        }

        targetInfo.targetId = "Message.ExtensionFrame";
        targetInfo.window = extensionFrameWindow;
        targetInfo.origin = configModule.EXTENSIONFRAME_BASEURL;
        targetInfo.encKey = decKey;

        extensionFrameProxy.setTargetInfo(targetInfo);

        //post ready extensionFrame FrameReady message 
        extensionFrameProxy.postMessage("FrameReady", {senderDecKey: decKey});

        extensionFrameProxy.setDecKey(decKey);
    });

    //post topFrame FrameReady msg
    topFrameProxy.postMessage("FrameReady");
};

Handshake.frames.extensionFrame = function (topFrameProxy, frameMessageBroker, secureFrameProxyGroup) {

    var frameReadyEventBroker = new FrameReadyEventBroker();
    frameReadyEventBroker.setFrameMessageBroker(frameMessageBroker);

    //prepare callback for FrameReady: post HandshakeResponse msg to frame
    frameReadyEventBroker.onFrameReady(function (frameProxy, messageObj) {
        console.log(__GLOBAL_LOG_PREFIX__, "ExtensionFrame: Frame Ready");

        var message = messageObj.message;
        var senderDecKey = null;

        if (message != null) {

            senderDecKey = message.senderDecKey;
        }

        var secureFrameProxy = new SecureFrameProxy();

        var targetInfo = frameProxy.getTargetInfo();
        targetInfo.encKey = senderDecKey;
        secureFrameProxy.setTargetInfo(targetInfo);

        secureFrameProxy.setDecKey(senderDecKey);
        secureFrameProxy.setSenderId(frameProxy.getSenderId());

        function compareTargetSource (proxyA, proxyB) {

            if (proxyA === proxyB) {
                return true;
            }

            return proxyA.hasSameTargetSource(proxyB);
        }

        var existedSecureFrameProxy = secureFrameProxyGroup.isAlreadyAdded(secureFrameProxy, compareTargetSource);

        if (existedSecureFrameProxy != null) {
            console.info(__GLOBAL_LOG_PREFIX__, "ExtensionFrame: Disable frame: " + targetInfo.targetId);

            existedSecureFrameProxy.setEnable(false);

        } else {
            console.info(__GLOBAL_LOG_PREFIX__, "ExtensionFrame: Handshake done, frame: " + targetInfo.targetId);

            if (senderDecKey == null) {

                secureFrameProxy.setEnable(false);

            } else {

                secureFrameProxy.postMessage("HandshakeResponse", "Done handshake!");
            }

            secureFrameProxyGroup.addMessageProxy(secureFrameProxy);
        } 
    });

    //post ExtenstionFrameReady to topFrame
    topFrameProxy.postMessage("ExtensionFrameReady");
};

Handshake.extension = {};

Handshake.extension.extensionFrame = function (frameMessageBroker, extensionProxy, eventPublisher) {

    var frameReadyEventBroker = new FrameReadyEventBroker();
    frameReadyEventBroker.setFrameMessageBroker(frameMessageBroker);

    //prepare callback for ExtensionReady: forward message to extension
    frameReadyEventBroker.onExtensionReady(function (frameProxy, messageObj) {
        console.log(__GLOBAL_LOG_PREFIX__, "ExtensionFrame: Extension Ready");

        var targetInfoTmp = messageObj.message;

        if (targetInfoTmp == null) {

            return;
        }

        var targetInfo = extensionProxy.getTargetInfo();

        targetInfo.elementId = targetInfoTmp.elementId;
        targetInfo.eventName = targetInfoTmp.eventName;

        extensionProxy.setTargetInfo(targetInfo);

        eventPublisher.sendMessage("ExtensionProxyReady");
    });

};

Handshake.topBar = {};

Handshake.topBar.topFrame = function (frameMessageBroker, extensionFrameProxy) {

    var frameReadyEventBroker = new FrameReadyEventBroker();
    frameReadyEventBroker.setFrameMessageBroker(frameMessageBroker);

    frameReadyEventBroker.onTopBarReady(function (frameProxy, messageObj) {

        // find extension frame index
        var extensionFrameTargetInfo = extensionFrameProxy.getTargetInfo();
        var extensionFrameIndex = Handshake.util.getExtensionFrameIndex(extensionFrameTargetInfo.window);

        // setup topBarProxy
        var targetInfo = frameProxy.getTargetInfo();

        targetInfo.origin = configModule.EXTENSIONFRAME_BASEURL;

        frameProxy.setTargetInfo(targetInfo);


        // tell topbar
        frameProxy.postMessage("ExtensionFrameReady",
            {
                extensionFrameIndex: extensionFrameIndex
            }
        );
    });
};

Handshake.topBar.topBar = function (topFrameProxy, extensionFrameProxy) {

    topFrameProxy.oneMessage("ExtensionFrameReady", function(messageObj, messageProxy){
        console.log(__GLOBAL_LOG_PREFIX__, "Frame: ExtensionFrame Ready");

        var messageContent = messageObj.message;

        if (messageContent == null ||
            messageContent.extensionFrameIndex == null) {

            return;
        }

        var extensionFrameWindow = null;

        try {

            extensionFrameWindow = window.top.frames["extensionFrame"];

        } catch(e) {

            console.info(__GLOBAL_LOG_PREFIX__, "Cannot retrieve extensionFrame using name");
        }

        if (Util.isWindowAvailable(extensionFrameWindow) === false &&
            messageContent.extensionFrameIndex !== -1) {

            console.info(__GLOBAL_LOG_PREFIX__, "Retrieve extensionFrame using index");
            extensionFrameWindow = window.top.frames[messageContent.extensionFrameIndex];
        }

        if (Util.isWindowAvailable(extensionFrameWindow) === false) {

            console.error(__GLOBAL_LOG_PREFIX__, "Cannot retrieve extensionFrame!!");
            return;
        }
        
        var targetInfo = extensionFrameProxy.getTargetInfo();

        targetInfo.targetId = "Message.ExtensionFrame";
        targetInfo.window = extensionFrameWindow;
        targetInfo.origin = configModule.EXTENSIONFRAME_BASEURL;

        extensionFrameProxy.setTargetInfo(targetInfo);

        extensionFrameProxy.postMessage("TopBarReady");
    });

    topFrameProxy.postMessage("TopBarReady");
};

Handshake.topBar.extensionFrame = function (topBarProxy, frameMessageBroker) {

    var frameReadyEventBroker = new FrameReadyEventBroker();
    frameReadyEventBroker.setFrameMessageBroker(frameMessageBroker);

    frameReadyEventBroker.onTopBarReady(function (frameProxy, messageObj) {

        var targetInfo = frameProxy.getTargetInfo();

        targetInfo.origin = configModule.EXTENSIONFRAME_BASEURL;

        topBarProxy.setTargetInfo(targetInfo);

        var messageObjTmp = {
            targetId: messageObj.targetId,
            messageId: "TopBarProxyReady",
            message: null,
            senderId: messageObj.senderId
        };

        topBarProxy.forwardMessage(messageObjTmp);
    });
};

module.exports = Handshake;